import secondaryComponents from "..";
import { BankEmptyIcon } from "../../../assets/svgIcons";
import useBankAccountsListLogic from "./useBankAccountsListLogic";
import { RoutedModal } from "../../common";

const BankAccountsList = ({ banks, refetch, metaDetails, gotoPage }) => {
  const {
    instance,
    selectedBank,
    setSelectedBank,
    bankInfo,
    isFetchingBankInfo,
    selectedDeleteAccount,
    setSelectedDeleteAccount,
  } = useBankAccountsListLogic({
    banks,
    refetch,
  });
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <div>
      <secondaryComponents.TableHelper
        getTableProps={getTableProps}
        getTableBodyProps={getTableBodyProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
      >
        <div className="text-center mt-5">
          <BankEmptyIcon />
          <h5>You have no banks</h5>
          <p>When you do, they would appear here.</p>
        </div>
      </secondaryComponents.TableHelper>

      {banks?.length > 0 && (
        <div className="mt-auto">
          <secondaryComponents.Pagination
            totalPageNumber={metaDetails?.last_page}
            handlePageClick={(value) => gotoPage(value?.selected + 1)}
            currentPage={metaDetails?.current_page}
          />
        </div>
      )}

      {/* update */}
      <secondaryComponents.LoaderHelper isLoading={isFetchingBankInfo}>
        <RoutedModal
          isActive={!!selectedBank}
          closeModal={() => setSelectedBank(null)}
          width={700}
          headerTitle="Edit Bank Account"
          headerDescription="Make changes to your bank account details to keep your financial records accurate and up-to-date."
          style={{ height: "auto" }}
        >
          <secondaryComponents.AddBankAccount
            closeWidget={() => setSelectedBank(null)}
            handleFetchbanks={refetch}
            isEditMode={true}
            bankInfo={bankInfo}
          />
        </RoutedModal>
      </secondaryComponents.LoaderHelper>

      {/* delete modal */}
      <secondaryComponents.LoaderHelper isLoading={isFetchingBankInfo}>
        <secondaryComponents.Modal
          isActive={selectedDeleteAccount !== null}
          closeModal={() => setSelectedDeleteAccount(null)}
          width={500}
        >
          <secondaryComponents.BankAccountDeletion
            closeWidget={() => setSelectedDeleteAccount(null)}
            bankDetails={bankInfo}
            selectedDeleteAccount={selectedDeleteAccount}
            handleFetchBanks={refetch}
          />
        </secondaryComponents.Modal>
      </secondaryComponents.LoaderHelper>
      {/* delete modal */}
    </div>
  );
};

export default BankAccountsList;
